/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BadRequest,
  Forbidden,
  GetOrganizations200ResponseInner,
  GetOrganizationsWithAccounts200ResponseInner,
  InternalServerError,
  PutOrganizationsWithAccounts200Response,
  PutOrganizationsWithAccountsRequest,
  ServiceUnavailable,
  Unauthorized,
  UnprocessableEntity,
  UploadAccountCsv200Response,
} from '../models/index';
import {
    BadRequestFromJSON,
    BadRequestToJSON,
    ForbiddenFromJSON,
    ForbiddenToJSON,
    GetOrganizations200ResponseInnerFromJSON,
    GetOrganizations200ResponseInnerToJSON,
    GetOrganizationsWithAccounts200ResponseInnerFromJSON,
    GetOrganizationsWithAccounts200ResponseInnerToJSON,
    InternalServerErrorFromJSON,
    InternalServerErrorToJSON,
    PutOrganizationsWithAccounts200ResponseFromJSON,
    PutOrganizationsWithAccounts200ResponseToJSON,
    PutOrganizationsWithAccountsRequestFromJSON,
    PutOrganizationsWithAccountsRequestToJSON,
    ServiceUnavailableFromJSON,
    ServiceUnavailableToJSON,
    UnauthorizedFromJSON,
    UnauthorizedToJSON,
    UnprocessableEntityFromJSON,
    UnprocessableEntityToJSON,
    UploadAccountCsv200ResponseFromJSON,
    UploadAccountCsv200ResponseToJSON,
} from '../models/index';

export interface GetOrganizationsRequest {
    sort?: string;
    include?: GetOrganizationsIncludeEnum;
}

export interface GetOrganizationsWithAccountsRequest {
    organizationCode?: string;
    companyCode?: string;
    companyId?: string;
    salesOfficeId?: string;
    status?: number;
    role?: number;
    accountNameKeyword?: string;
    emailKeyword?: string;
    sort?: GetOrganizationsWithAccountsSortEnum;
}

export interface PutOrganizationsWithAccountsOperationRequest {
    putOrganizationsWithAccountsRequest: PutOrganizationsWithAccountsRequest;
}

export interface UploadOrganizationAccountsCsvRequest {
    file: Blob;
}

/**
 * 
 */
export class OrganizationsApi extends runtime.BaseAPI {

    /**
     * 組織一覧情報取得
     */
    async getOrganizationsRaw(requestParameters: GetOrganizationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetOrganizations200ResponseInner>>> {
        const queryParameters: any = {};

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['include'] != null) {
            queryParameters['include'] = requestParameters['include'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/organizations`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetOrganizations200ResponseInnerFromJSON));
    }

    /**
     * 組織一覧情報取得
     */
    async getOrganizations(requestParameters: GetOrganizationsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetOrganizations200ResponseInner>> {
        const response = await this.getOrganizationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 組織に紐付くアカウント一覧情報の取得
     */
    async getOrganizationsWithAccountsRaw(requestParameters: GetOrganizationsWithAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetOrganizationsWithAccounts200ResponseInner>>> {
        const queryParameters: any = {};

        if (requestParameters['organizationCode'] != null) {
            queryParameters['organization_code'] = requestParameters['organizationCode'];
        }

        if (requestParameters['companyCode'] != null) {
            queryParameters['company_code'] = requestParameters['companyCode'];
        }

        if (requestParameters['companyId'] != null) {
            queryParameters['company_id'] = requestParameters['companyId'];
        }

        if (requestParameters['salesOfficeId'] != null) {
            queryParameters['sales_office_id'] = requestParameters['salesOfficeId'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['role'] != null) {
            queryParameters['role'] = requestParameters['role'];
        }

        if (requestParameters['accountNameKeyword'] != null) {
            queryParameters['account_name_keyword'] = requestParameters['accountNameKeyword'];
        }

        if (requestParameters['emailKeyword'] != null) {
            queryParameters['email_keyword'] = requestParameters['emailKeyword'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/organizations/accounts`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetOrganizationsWithAccounts200ResponseInnerFromJSON));
    }

    /**
     * 組織に紐付くアカウント一覧情報の取得
     */
    async getOrganizationsWithAccounts(requestParameters: GetOrganizationsWithAccountsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetOrganizationsWithAccounts200ResponseInner>> {
        const response = await this.getOrganizationsWithAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 指定された組織情報（organization_code, company_code, company_id, sales_office_id）に紐付くアカウント一覧を更新します。<br> データベース上の既存の紐付け情報とリクエスト内のアカウントIDリストを比較し、以下の処理を行います。<br><br>  - リクエストにのみ存在するアカウントIDは新規に紐付けを登録<br> - データベースにのみ存在するアカウントIDは紐付けを削除<br><br>  ※全体置換（差分更新）によって紐付け情報を最新化します。 
     * 組織に紐付くアカウント一覧情報の更新
     */
    async putOrganizationsWithAccountsRaw(requestParameters: PutOrganizationsWithAccountsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PutOrganizationsWithAccounts200Response>> {
        if (requestParameters['putOrganizationsWithAccountsRequest'] == null) {
            throw new runtime.RequiredError(
                'putOrganizationsWithAccountsRequest',
                'Required parameter "putOrganizationsWithAccountsRequest" was null or undefined when calling putOrganizationsWithAccounts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/organizations/accounts`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PutOrganizationsWithAccountsRequestToJSON(requestParameters['putOrganizationsWithAccountsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PutOrganizationsWithAccounts200ResponseFromJSON(jsonValue));
    }

    /**
     * 指定された組織情報（organization_code, company_code, company_id, sales_office_id）に紐付くアカウント一覧を更新します。<br> データベース上の既存の紐付け情報とリクエスト内のアカウントIDリストを比較し、以下の処理を行います。<br><br>  - リクエストにのみ存在するアカウントIDは新規に紐付けを登録<br> - データベースにのみ存在するアカウントIDは紐付けを削除<br><br>  ※全体置換（差分更新）によって紐付け情報を最新化します。 
     * 組織に紐付くアカウント一覧情報の更新
     */
    async putOrganizationsWithAccounts(requestParameters: PutOrganizationsWithAccountsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PutOrganizationsWithAccounts200Response> {
        const response = await this.putOrganizationsWithAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 組織に紐付くアカウント一覧情報CSVの登録
     */
    async uploadOrganizationAccountsCsvRaw(requestParameters: UploadOrganizationAccountsCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UploadAccountCsv200Response>> {
        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError(
                'file',
                'Required parameter "file" was null or undefined when calling uploadOrganizationAccountsCsv().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }


        let urlPath = `/organizations/accounts/csv`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UploadAccountCsv200ResponseFromJSON(jsonValue));
    }

    /**
     * 組織に紐付くアカウント一覧情報CSVの登録
     */
    async uploadOrganizationAccountsCsv(requestParameters: UploadOrganizationAccountsCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UploadAccountCsv200Response> {
        const response = await this.uploadOrganizationAccountsCsvRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetOrganizationsIncludeEnum = {
    All: 'all'
} as const;
export type GetOrganizationsIncludeEnum = typeof GetOrganizationsIncludeEnum[keyof typeof GetOrganizationsIncludeEnum];
/**
 * @export
 */
export const GetOrganizationsWithAccountsSortEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetOrganizationsWithAccountsSortEnum = typeof GetOrganizationsWithAccountsSortEnum[keyof typeof GetOrganizationsWithAccountsSortEnum];
